import {defineNuxtPlugin, navigateTo} from "#app";
import {useAuth} from "~/stores/auth";

export default defineNuxtPlugin(async(context) => {
    try {
        await useAuth().loadUser()
    } catch (e) {
    }
})
